// Phase 4.4 — AI Culling Assist
export const CULL = {
  root: 'cull-review-page',
  backLink: 'cull-back-link',
  title: 'cull-gallery-title',
  statusBadge: 'cull-status-badge',
  // run panel
  runPanel: 'cull-run-panel',
  aiSwitch: 'cull-ai-eyes-switch',
  estimate: 'cull-estimate',
  runButton: 'cull-run-button',
  clearButton: 'cull-clear-button',
  progress: 'cull-progress',
  progressLabel: 'cull-progress-label',
  error: 'cull-error',
  aiError: 'cull-ai-error',
  // summary + filters
  summary: 'cull-summary',
  summaryStat: (k) => `cull-summary-${k}`,
  filter: (k) => `cull-filter-${k}`,
  sortSelect: 'cull-sort-select',
  selectAllVisible: 'cull-select-all-visible',
  // grid
  grid: 'cull-grid',
  empty: 'cull-empty',
  noResults: 'cull-no-results',
  card: (id) => `cull-card-${id}`,
  cardCheckbox: (id) => `cull-card-checkbox-${id}`,
  badge: (id, kind) => `cull-badge-${kind}-${id}`,
  sharpness: (id) => `cull-sharpness-${id}`,
  note: (id) => `cull-note-${id}`,
  // duplicate groups
  groups: 'cull-groups',
  group: (gid) => `cull-group-${gid}`,
  groupSelect: (gid) => `cull-group-select-${gid}`,
  groupCompare: (gid) => `cull-group-compare-${gid}`,
  // selection bar
  selectionBar: 'cull-selection-bar',
  selectionCount: 'cull-selection-count',
  compareButton: 'cull-compare-button',
  hideButton: 'cull-hide-button',
  unhideButton: 'cull-unhide-button',
  deleteButton: 'cull-delete-button',
  clearSelection: 'cull-clear-selection',
  deleteConfirm: 'cull-delete-confirm',
  deleteCancel: 'cull-delete-cancel',
  // compare dialog
  compareDialog: 'cull-compare-dialog',
  comparePane: (id) => `cull-compare-pane-${id}`,
  compareZoom: 'cull-compare-zoom',
  compareClose: 'cull-compare-close',
};
